import React, { useEffect, useState } from 'react';
import css from './LoadingSpinner.module.css';
import clsx from 'clsx';
import { Paragraph } from '../text';
import { StackedRow } from '../containers';
import { LoadingSpinnerSize } from './LoadingSpinnerSize';

export interface LoadingSpinnerProps {
  label?: string;
  size?: LoadingSpinnerSize;
  delayInMs?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = (
  props: LoadingSpinnerProps
) => {
  const { size = LoadingSpinnerSize.Medium, delayInMs = 1000 } = props;
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    if (delayInMs) {
      const timer: NodeJS.Timeout = setTimeout(() => {
        setShow(true);
      }, delayInMs);

      return (): void => {
        clearTimeout(timer);
      };
    } else {
      setShow(true);
    }
  }, [delayInMs]);

  const sizeStyle = (): string => {
    switch (size) {
      case LoadingSpinnerSize.Small:
        return css.small;
      case LoadingSpinnerSize.Large:
        return css.large;
      case LoadingSpinnerSize.Medium:
      default:
        return css.medium;
    }
  };

  return (
    <>
      {show && (
        <StackedRow>
          <span className={clsx(css.circle, sizeStyle())}></span>
          {props.label && (
            <div className={css.loadingTextContainer}>
              <Paragraph className={css.loadingText} text={props.label} />
            </div>
          )}
        </StackedRow>
      )}
    </>
  );
};

export default LoadingSpinner;
